import React, { useEffect, useState } from "react";
import VendorHeader from "../../CustomComponents/Property/VendorHeader/VendorHeader";
import SideBar from "../../CustomComponents/Property/SideBar/SideBar";
import { showErrorToast, showSuccessToast } from "../../assets/toastUtils";
import { useParams } from "react-router-dom";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Loader from "../../CustomComponents/Loader/Loader";
import NoDataFound from "../../CustomComponents/NoDataFound/NoDataFound";
import ReactQueryInput from "./ReactQueryInout";

const NewRules = () => {
  const [allrules, setAllRules] = useState([]);
  const vendorToken = localStorage.getItem("token");
  const { id } = useParams();

  const [editPolicy, setEditPolicy] = useState(false);
  const [editingKey, setEditingKey] = useState(null);
  const [ruleDetails, setRuleDetails] = useState({});

  const fetchPropertyData = async () => {
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${vendorToken}`);
    myHeaders.append("Cookie", process.env.REACT_APP_COOKIE);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/accomodation/crud/edit/${id}`,
        requestOptions
      );
      const result = await response.json();

      if (response.ok) {
        const transformedData =
          result?.data?.rules?.length > 0 &&
          Object.entries(result?.data?.rules[0]).reduce(
            (acc, [key, value]) => {
              const newKey = `${key}_policy`;
              acc[newKey] = value;
              return acc;
            },
            {}
          );
        setPolicyData(transformedData);
        // setPolicyData(result?.data?.rules)
        // setAllRules(result?.data?.rules);
      } else {
        throw new Error(result.message || "Something went wrong");
      }
    } catch (err) {
      console.error("Error fetching property data:", err);
    }
  };

  useEffect(() => {
    if (id) {
      fetchPropertyData();
    }
  }, [id]);

  const modules = {
    toolbar: [
      [{ header: "1" }, { header: "2" }, { font: [] }],
      [{ size: [] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image", "video"],
      ["clean"],
    ],
  };

  const formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "video",
  ];

  const handleEditorChange = (value) => {
    setRuleDetails((prev) => ({ ...prev, content: value }));
  };

  // Handle edit click
  const handleEdit = (key, value) => {
    setEditingKey(key);
    setRuleDetails({ key, content: value });
  };

  // const handleSave = async () => {
  //   try {
  //     const updatedData = allrules.reduce((acc, rule) => {
  //       Object.entries(rule).forEach(([key, value]) => {
  //         if (key === ruleDetails.key) {
  //           acc[key] = ruleDetails.content; // Update the current edited content
  //         } else {
  //           acc[key] = value; // Include unchanged policies
  //         }
  //       });
  //       return acc;
  //     }, {});

  //     const result = await updatePolicy(updatedData);

  //     // Update the UI
  //     const updatedRules = allrules.map((rule) => {
  //       if (rule[ruleDetails.key]) {
  //         return { ...rule, [ruleDetails.key]: ruleDetails.content };
  //       }
  //       return rule;
  //     });

  //     setAllRules(updatedRules);
  //     setEditingKey(null);
  //     console.log("Policy updated successfully:", result);
  //   } catch (error) {
  //     console.error("Failed to update policy:", error);
  //   }
  // };
  const [policyData, setPolicyData] = useState({
    cancellation_policy: "",
    // name: "",
    // type: "",
    // model: "",
    // seat: "",
    // status: "",
    // featured: "",
    // online: "",
    // fuel_type: "",
    // supplier_id: "",
  });

  const handleSubmitUpdate = async (e) => {
    e.preventDefault();
    const url = `${process.env.REACT_APP_BASE_URL}/api/v1/website/accomodation/crud/policy/update/${id}`;
    const headers = new Headers();
    headers.append("Accept", "application/json");
    headers.append("Authorization", `Bearer ${vendorToken}`);

    const formData = new FormData();
    Object.entries(policyData).forEach(([key, value]) => {
      formData?.append(key, value);
    });

    const requestOptions = {
      method: "POST",
      headers: headers,
      body: formData,
      redirect: "follow",
    };

    try {
      const response = await fetch(url, requestOptions);
      const result = await response.json();
      if (result.success) {
        showSuccessToast(result.message);
      } else {
        showErrorToast(result.message)
      }
    } catch (error) {
      console.error("Error updating policy:", error);
      throw error;
    }
  };

  return (
    <>
      {/* <div className="sidebar_main_div new_sidebar_main_div"> */}
      {/* <SideBar allPropertiesPage={false} />
        <div className="agent-info-container">
          <VendorHeader showSelectProperty={true} vendorProperty={false} /> */}

      {/* <section className="w-full mt-20">
        <div className="flex justify_content_between">
          <h4>Rules</h4>
        </div>
        <form>
          {allrules?.length > 0 ? (
            allrules?.map((rule, index) => (
              <div key={index} className="rule-container">
                {Object.entries(rule).map(([key, value]) => (
                  <div key={key} className="rule-item">
                    <div className="flex justify_content_between align_items_center">
                      <h5
                        htmlFor={`${key}_description`}
                        style={{ textTransform: "capitalize" }}
                      >
                        {key.replace(/_/g, " ")}
                      </h5>
                      {editingKey === key ? (
                        <div
                          className="vendor_common_property cursor_pointer"
                          onClick={handleSave}
                        >
                          Save
                        </div>
                      ) : (

                        <svg onClick={() => handleEdit(key, value)}
                          width="26"
                          height="27"
                          viewBox="0 0 26 27"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <mask
                            id="mask0_4568_4221"
                            style={{ maskType: "alpha" }}
                            maskUnits="userSpaceOnUse"
                            x="0"
                            y="0"
                            width="26"
                            height="27"
                          >
                            <rect
                              y="0.5"
                              width="26"
                              height="26"
                              fill="#D9D9D9"
                            />
                          </mask>
                          <g mask="url(#mask0_4568_4221)">
                            <path
                              d="M5.41667 21.0833H6.96042L17.55 10.4938L16.0063 8.95L5.41667 19.5396V21.0833ZM3.25 23.25V18.6458L17.55 4.37292C17.7667 4.17431 18.0059 4.02083 18.2677 3.9125C18.5295 3.80417 18.8049 3.75 19.0938 3.75C19.3826 3.75 19.6625 3.80417 19.9333 3.9125C20.2042 4.02083 20.4389 4.18333 20.6375 4.4L22.1271 5.91667C22.3438 6.11528 22.5017 6.35 22.601 6.62083C22.7003 6.89167 22.75 7.1625 22.75 7.43333C22.75 7.72222 22.7003 7.99757 22.601 8.25938C22.5017 8.52118 22.3438 8.76042 22.1271 8.97708L7.85417 23.25H3.25ZM16.7646 9.73542L16.0063 8.95L17.55 10.4938L16.7646 9.73542Z"
                              fill="#3968ED"
                            />
                          </g>
                        </svg>

                      )}
                    </div>
                    <div className="border p_10 rounded mt-5">
                      {editingKey === key ? (
                        <ReactQuill
                          className="mt-10"
                          value={ruleDetails.content}
                          onChange={handleEditorChange}
                          modules={modules}
                          formats={formats}
                        />
                      ) : (
                        <p dangerouslySetInnerHTML={{ __html: value }}></p>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            ))
          ) : (
            <>
              {" "}
              <NoDataFound />
            </>
          )}
        </form>
      </section>
     */}

      <div className="vendor_new_rules">
        <form onSubmit={(e) => handleSubmitUpdate(e)}>
          <div>
            <b>Cancellation Policy</b>
          </div>
          <div className="property_rules_react_qill_container">
            <ReactQueryInput
              inputHeight="200px"
              // heading="Content"
              name="cancellation_policy"
              value={policyData.cancellation_policy}
              getDataFromChild={(content) => {
                setPolicyData({ ...policyData, cancellation_policy: content });
              }}
            />
          </div>

          <div className="mt-10">
            <button type="submit" className="vendor_common_property">Update</button>
          </div>
        </form>
      </div>
      <div className="vendor_new_rules">
        {" "}
        <form onSubmit={(e) => handleSubmitUpdate(e)}>
          <div>
            <b>Terms and conditions Policy</b>
          </div>
          <div className="property_rules_react_qill_container">
            <ReactQueryInput
              inputHeight="200px"
              name="terms_and_condition_policy"
              value={policyData?.terms_and_condition_policy}
              getDataFromChild={(content) => {
                setPolicyData({
                  ...policyData,
                  terms_and_condition_policy: content,
                });
              }}
            />
          </div>

          <div className="mt-10">
            <button type="submit" className="vendor_common_property">Update</button>

          </div>
        </form>
      </div>
      <div className="vendor_new_rules">
        {" "}
        <form onSubmit={(e) => handleSubmitUpdate(e)}>
          <div>
            <b>Property Restrictions Policy</b>
          </div>
          <div className="property_rules_react_qill_container">
            <ReactQueryInput
              inputHeight="200px"
              name="property_restrictions_policy"
              value={policyData?.property_restrictions_policy}
              getDataFromChild={(content) => {
                setPolicyData({
                  ...policyData,
                  property_restrictions_policy: content,
                });
              }}
            />
          </div>

          <div className="mt-10">
            {" "}
            <button type="submit" className="vendor_common_property">Update</button>

          </div>
        </form>
      </div>
      <div className="vendor_new_rules">
        {" "}
        <form onSubmit={(e) => handleSubmitUpdate(e)}>
          <div>
            <b>Property Accessibility Policy</b>
          </div>
          <div className="property_rules_react_qill_container">
            <ReactQueryInput
              inputHeight="200px"
              name="property_accessibility_policy"
              value={policyData?.property_accessibility_policy}
              getDataFromChild={(content) => {
                setPolicyData({
                  ...policyData,
                  property_accessibility_policy: content,
                });
              }}
            />
          </div>

          <div className="mt-10">
            <button type="submit" className="vendor_common_property">Update</button>

          </div>
        </form>
      </div>
      <div className="vendor_new_rules">
        {" "}
        <form onSubmit={(e) => handleSubmitUpdate(e)}>
          <div>
            <b>Child And Extra Bed Policy</b>
          </div>
          <div className="property_rules_react_qill_container">
            <ReactQueryInput
              inputHeight="200px"
              name="child_and_extra_bed_policy"
              value={policyData?.child_and_extra_bed_policy}
              getDataFromChild={(content) => {
                setPolicyData({
                  ...policyData,
                  child_and_extra_bed_policy: content,
                });
              }}
            />
          </div>

          <div className="mt-10">
            {" "}
            <button type="submit" className="vendor_common_property">Update</button>

          </div>
        </form>
      </div>
      <div className="vendor_new_rules">
        {" "}
        <form onSubmit={(e) => handleSubmitUpdate(e)}>
          <div>
            <b>Smoking Alcohol Consumption Rules</b>
          </div>
          <div className="property_rules_react_qill_container">
            <ReactQueryInput
              inputHeight="200px"
              name="smoking_alcohol_consumption_rules_policy"
              value={policyData?.smoking_alcohol_consumption_rules_policy}
              getDataFromChild={(content) => {
                setPolicyData({
                  ...policyData,
                  smoking_alcohol_consumption_rules_policy: content,
                });
              }}
            />
          </div>

          <div className="mt-10">
            <button type="submit" className="vendor_common_property">Update</button>

          </div>
        </form>
      </div>
      <div className="vendor_new_rules">
        {" "}
        <form onSubmit={(e) => handleSubmitUpdate(e)}>
          <div>
            <b>Food Arrangement</b>
          </div>
          <div className="property_rules_react_qill_container">
            <ReactQueryInput
              inputHeight="200px"
              name="food_arrangement_policy"
              value={policyData?.food_arrangement_policy}
              getDataFromChild={(content) => {
                setPolicyData({
                  ...policyData,
                  food_arrangement_policy: content,
                });
              }}
            />
          </div>

          <div className="mt-10">
            <button type="submit" className="vendor_common_property">Update</button>

          </div>
        </form>
      </div>
      <div className="vendor_new_rules">
        <form onSubmit={(e) => handleSubmitUpdate(e)}>
          <div>
            <b>ID Proof Policy</b>
          </div>
          <div className="property_rules_react_qill_container">
            <ReactQueryInput
              inputHeight="200px"
              name="id_proof_policy"
              value={policyData?.id_proof_policy}
              getDataFromChild={(content) => {
                setPolicyData({ ...policyData, id_proof_policy: content });
              }}
            />
          </div>

          <div className="mt-10">
            <button type="submit" className="vendor_common_property">Update</button>

          </div>
        </form>
      </div>
      <div className="vendor_new_rules">
        <form onSubmit={(e) => handleSubmitUpdate(e)}>
          <div>
            <b>Guest Profile</b>
          </div>
          <div className="property_rules_react_qill_container">
            <ReactQueryInput
              inputHeight="200px"
              name="guest_profile_policy"
              value={policyData?.guest_profile_policy}
              getDataFromChild={(content) => {
                setPolicyData({ ...policyData, guest_profile_policy: content });
              }}
            />
          </div>

          <div className="mt-10">
            <button type="submit" className="vendor_common_property">Update</button>

          </div>
        </form>
      </div>
      <div className="vendor_new_rules">
        <form onSubmit={(e) => handleSubmitUpdate(e)}>
          <div>
            <b>Guest Profile Hourly</b>
          </div>
          <div className="property_rules_react_qill_container">
            <ReactQueryInput
              inputHeight="200px"
              name="guest_profile_hourly_policy"
              value={policyData?.guest_profile_hourly_policy}
              getDataFromChild={(content) => {
                setPolicyData({
                  ...policyData,
                  guest_profile_hourly_policy: content,
                });
              }}
            />
          </div>

          <div className="mt-10">
            <button type="submit" className="vendor_common_property">Update</button>

          </div>
        </form>
      </div>
      <div className="vendor_new_rules">
        <form onSubmit={(e) => handleSubmitUpdate(e)}>
          <div>
            <b>Pets Related Policy</b>
          </div>
          <div className="property_rules_react_qill_container">
            <ReactQueryInput
              inputHeight="200px"
              name="pets_related_policy"
              value={policyData?.pets_related_policy}
              getDataFromChild={(content) => {
                setPolicyData({ ...policyData, pets_related_policy: content });
              }}
            />
          </div>

          <div className="mt-10">
            <button type="submit" className="vendor_common_property">Update</button>

          </div>
        </form>
      </div>
      <div className="vendor_new_rules">
        {" "}
        <form onSubmit={(e) => handleSubmitUpdate(e)}>
          <div>
            <b>Other Rules</b>
          </div>
          <div className="property_rules_react_qill_container">
            <ReactQueryInput
              inputHeight="200px"
              name="other_rules_policy"
              value={policyData?.other_rules_policy}
              getDataFromChild={(content) => {
                setPolicyData({ ...policyData, other_rules_policy: content });
              }}
            />
          </div>

          <div className="mt-10">
            <button type="submit" className="vendor_common_property">Update</button>
          </div>
        </form>
      </div>
    </>
  );
};

export default NewRules;
